"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "assertWebGL2Context", {
  enumerable: true,
  get: function get() {
    return _webglChecks.assertWebGL2Context;
  }
});
Object.defineProperty(exports, "assertWebGLContext", {
  enumerable: true,
  get: function get() {
    return _webglChecks.assertWebGLContext;
  }
});
Object.defineProperty(exports, "createGLContext", {
  enumerable: true,
  get: function get() {
    return _context.createGLContext;
  }
});
Object.defineProperty(exports, "cssToDevicePixels", {
  enumerable: true,
  get: function get() {
    return _devicePixels.cssToDevicePixels;
  }
});
Object.defineProperty(exports, "cssToDeviceRatio", {
  enumerable: true,
  get: function get() {
    return _devicePixels.cssToDeviceRatio;
  }
});
Object.defineProperty(exports, "getContextDebugInfo", {
  enumerable: true,
  get: function get() {
    return _context.getContextDebugInfo;
  }
});
Object.defineProperty(exports, "getParameters", {
  enumerable: true,
  get: function get() {
    return _unifiedParameterApi.getParameters;
  }
});
Object.defineProperty(exports, "getWebGL2Context", {
  enumerable: true,
  get: function get() {
    return _webglChecks.getWebGL2Context;
  }
});
Object.defineProperty(exports, "instrumentGLContext", {
  enumerable: true,
  get: function get() {
    return _context.instrumentGLContext;
  }
});
Object.defineProperty(exports, "isWebGL", {
  enumerable: true,
  get: function get() {
    return _webglChecks.isWebGL;
  }
});
Object.defineProperty(exports, "isWebGL2", {
  enumerable: true,
  get: function get() {
    return _webglChecks.isWebGL2;
  }
});
Object.defineProperty(exports, "log", {
  enumerable: true,
  get: function get() {
    return _log.log;
  }
});
Object.defineProperty(exports, "polyfillContext", {
  enumerable: true,
  get: function get() {
    return _polyfillContext.polyfillContext;
  }
});
Object.defineProperty(exports, "popContextState", {
  enumerable: true,
  get: function get() {
    return _trackContextState.popContextState;
  }
});
Object.defineProperty(exports, "pushContextState", {
  enumerable: true,
  get: function get() {
    return _trackContextState.pushContextState;
  }
});
Object.defineProperty(exports, "resetParameters", {
  enumerable: true,
  get: function get() {
    return _unifiedParameterApi.resetParameters;
  }
});
Object.defineProperty(exports, "resizeGLContext", {
  enumerable: true,
  get: function get() {
    return _context.resizeGLContext;
  }
});
Object.defineProperty(exports, "setParameters", {
  enumerable: true,
  get: function get() {
    return _unifiedParameterApi.setParameters;
  }
});
Object.defineProperty(exports, "trackContextState", {
  enumerable: true,
  get: function get() {
    return _trackContextState.trackContextState;
  }
});
Object.defineProperty(exports, "withParameters", {
  enumerable: true,
  get: function get() {
    return _unifiedParameterApi.withParameters;
  }
});

var _log = require("./utils/log");

var _webglChecks = require("./utils/webgl-checks");

var _polyfillContext = require("./polyfill/polyfill-context");

var _unifiedParameterApi = require("./state-tracker/unified-parameter-api");

var _trackContextState = require("./state-tracker/track-context-state");

var _context = require("./context/context");

var _devicePixels = require("./utils/device-pixels");
//# sourceMappingURL=index.js.map